module.exports = __webpack_public_path__ + "static/media/place-5.1fd53d1f.jpg";